export const Heading1 = ({ title }) => {
    return (
        <h1 className={ 'text-primary fw-bold pt-4 my-3' }>
            {title}
        </h1>
    );
}
